module.exports = __webpack_public_path__ + "static/media/arrow.2c8952e3.svg";